import { ServiceCenter } from './service-center';

export class Area {
	readonly id: number;
	name: string;
	description: string;
	serviceCenter: ServiceCenter;

	constructor(
		options: {
			id?: number;
			name?: string;
			description?: string;
			serviceCenter?: ServiceCenter;
		} = {}
	) {
		this.id = options.id || null;
		this.name = options.name || '';
		this.description = options.description || '';
		this.serviceCenter = options.serviceCenter || null;
	}
}
